import React from 'react';
import { Draggable as ReactSmoothDraggable } from 'react-smooth-dnd';

function NonDraggable({ children, ...other }) {
    return <div {...other}>{children}</div>;
}

export function Draggable({ draggable = true, ...props }) {
    if (draggable) {
        return <ReactSmoothDraggable {...props} />;
    }

    return <NonDraggable {...props} />;
}
